module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_fresh_green-fe881a7ccc21c34a143de1196336bdea.jpg";